module.exports = __webpack_public_path__ + "img/ring_r_i_1_1@2x.3888baf3.png";